import './header.scss'
import type { FC } from 'react'
import { Tooltip } from '@/common/components/tooltip/Tooltip'
import { ActionButtons } from './subcomponents/ActionButtons'
import { CinemaTabs } from './subcomponents/CinemaTabs'
import { Navigation } from './subcomponents/Navigation'
import { QuickBook } from './subcomponents/QuickBook'
import { SiteLogo } from './subcomponents/SiteLogo'

export const Header: FC = () => {
    return (
        <header>
            <CinemaTabs />
            <span className="header-content">
                <Navigation />
                <QuickBook />
                <SiteLogo />
                <ActionButtons />
                <Tooltip />
            </span>
        </header>
    )
}
